import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';

import { mediaPhone } from '../styles/breakpoints';

import GrafikPDFDownload from '../GrafikPDFDownload';
import DownloadMaterialButton from '../DownloadMaterialButton';
import DownloadPdf from '../DownloadPdf';

const Article = styled.article`
  position: relative;
  width: 306px;
  margin-left: auto;
  margin-right: auto;
`;

const DownloadMaterialButtonStyled = styled(DownloadMaterialButton)`
  position: absolute;
  top: 215px;
  ${mediaPhone} {
    top: 180px;
  }
  left: 0;
  right: 0;
  padding: 15px 0;
  border-radius: 3px;
  text-align: center;
`;

const DownloadMaterial = ({ className }) => (
  <Article className={className}>
    <DownloadPdf>
      <GrafikPDFDownload />
      <DownloadMaterialButtonStyled nolink />
    </DownloadPdf>
  </Article>
);

DownloadMaterial.propTypes = {
  className: PropTypes.string,
};

DownloadMaterial.defaultProps = {
  className: undefined,
};

export default DownloadMaterial;



// WEBPACK FOOTER //
// ./src/components/AboutMaterialDownload/DownloadMaterial.js